import * as types from './mutations-types'

export default {
  [types.MY_STORED_VALUE] (state, data) {
    state.myStoredValue = data.dataList
  },
  [types.STORED_VALUE_CARD_DEFINITION] (state, data) {
    state.storedValueCardDefinitionList = data
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/my-stored-value/store/mutations.js